import {
    tss,
} from 'app/tss'

export default tss
    .create(({
        theme,
    }) => {
        return {
            detailsViewContainer: {
                padding: theme.spacing(1),
                backgroundColor: theme.palette.secondary[50],
            },
            expandableDataGridOverwrites: {
                '& .MuiDataGrid-virtualScrollerRenderZone': {
                    transform: 'none !important',
                },
                '& .MuiDataGrid-root': {
                    transform: 'none !important',
                },
            },
        }
    })
